import { useEffect } from 'react';

import { useUserInfo } from 'store/useUserStore';
import token from 'utils/token';

declare global {
  interface Window {
    HubSpotConversations: any;
  }
}

export function useHubspot() {
  const userUniqueToken = token.getUserUniqueToken();
  const userInfo = useUserInfo();

  useEffect(() => {
    /* @ts-ignore */
    window['hsConversationsSettings'] = {
      loadImmediately: true,
      identificationEmail: userInfo?.email,
      identificationToken: typeof userUniqueToken === 'string' ? userUniqueToken : '',
    };

    const hubSpotScript = document.createElement('script');
    hubSpotScript.src = '//js-na1.hs-scripts.com/21677104.js';
    hubSpotScript.async = true;
    hubSpotScript.defer = true;
    hubSpotScript.id = 'hs-script-loader';
    document.body.appendChild(hubSpotScript);

    return () => {
      if (hubSpotScript && document.body.contains(hubSpotScript)) {
        document.body.removeChild(hubSpotScript);
      }
      // @ts-ignore
      window.hsConversationsSettings = {};
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
